import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Destination from "@/components/Destination";
import WhatsAppButton from "@/components/WhatsAppButton";
import Architecture from "@/components/Architecture";
import Amenities from "@/components/Amenities";
import Nature from "@/components/Nature";
import Residences from "@/components/Residences";
import Location from "@/components/Location";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    document.title = "Embassy South Reserve — Planned Around Nature";
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App bg-[#FAF9F6] text-[#1C1917]">
      <Nav />
      <main>
        <Hero />
        <Destination />
        <Architecture />
        <Amenities />
        <Nature />
        <Residences />
        <Location />
        <Enquiry />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
